export default __webpack_public_path__ + "bayes-equation4.png";